var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHappy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 16.5C33 25.6116 25.6116 33 16.5 33C7.3884 33 0 25.6116 0 16.5C0 7.3884 7.38459 0 16.5 0C25.6116 0 33 7.3884 33 16.5Z",
    fill: "#FFCE00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3946 14.3823C27.5623 14.489 27.7911 14.367 27.7911 14.165V14.1612C27.7911 12.9564 26.8151 11.9805 25.6104 11.9805C24.4057 11.9805 23.4297 12.9564 23.4297 14.1612V14.165C23.4297 14.367 23.6546 14.4852 23.8262 14.3823C24.3447 14.062 24.9546 13.8752 25.6104 13.8752C26.2661 13.8752 26.8761 14.062 27.3946 14.3823Z",
    fill: "#562912"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.14848 14.3823C9.32003 14.489 9.54496 14.367 9.54496 14.165V14.1612C9.54496 12.9564 8.56899 11.9805 7.36428 11.9805C6.15956 11.9805 5.18359 12.9564 5.18359 14.1612V14.165C5.18359 14.367 5.40853 14.4852 5.58009 14.3823C6.09857 14.062 6.70855 13.8752 7.36047 13.8752C8.0162 13.8752 8.62618 14.062 9.14848 14.3823Z",
    fill: "#562912"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.0656 18.9916C7.53949 19.1708 7.23831 19.7427 7.44418 20.2611C8.67177 23.372 12.2745 25.9912 16.5024 25.9912C20.7303 25.9912 24.333 23.372 25.5606 20.2611C25.7627 19.7427 25.4653 19.1708 24.9392 18.9916C19.8421 17.2684 13.1628 17.2684 8.0656 18.9916Z",
    fill: "#562912"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9688 24.9316C13.3183 25.5987 14.8662 25.9952 16.5055 25.9952C18.1486 25.9952 19.6926 25.5949 21.0422 24.9316C19.7918 23.9899 18.2173 23.4219 16.5055 23.4219C14.7899 23.4257 13.2192 23.9899 11.9688 24.9316Z",
    fill: "#CC342F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappy);
export default __webpack_public_path__ + "static/media/happy.909e53f545f618e565b8a0a08413ed9a.svg";
export { ForwardRef as ReactComponent };